import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule, FormArray, FormBuilder } from '@angular/forms';
import { Router } from "@angular/router";
import { ActivatedRoute } from '@angular/router';
import Utils from '../shared/utility';
import { GlobalService } from '../services/global.service';

@Component({
  selector: 'app-new-illustration-ltc-questionnaire',
  templateUrl: './new-illustration-ltc-questionnaire.component.html',
  styleUrls: ['./new-illustration-ltc-questionnaire.component.css']
})
export class NewIllustrationLtcQuestionnaireComponent implements OnInit {
  clientSpouseFullName: string;
  isMarried: boolean;

  metroAreaForm: FormGroup;
  additionalQuestionsForm: FormGroup;

  isLTCMetroAreaSelection: boolean;
  isTraditinalPremium: boolean;
  isAdditionalQuestion: boolean;
  isEnableUpdateButton: boolean;

  isCombinationReport: boolean = false;
  featAdditionalQuestions: boolean = false;

  public allStates: any[] = Utils.allStates;
  //married: boolean = false;
  clientSelectedState;
  spouseSelectedState;
  params: any;
  clientLTCMetroRegions = { Rows: [0] };
  spouseLTCMetroRegions = { Rows: [0] };
  isEditAll: boolean = false;

  constructor(private router: Router, private route: ActivatedRoute,private globalService: GlobalService) {
    // console.log('value',this.route.snapshot.paramMap.get('id'));
    //console.log(this.router.getCurrentNavigation().extras.state.params);
    this.params = (this.router.getCurrentNavigation().extras.state) ? this.router.getCurrentNavigation().extras.state.params : '';
    this.featAdditionalQuestions = localStorage.getItem('featAdditionalQuestions') == 'true' ? true: false;
    console.log('page load params', this.params)
    if (this.params == 'editAll' || this.params == '') {
        
      this.isEditAll = true;
    }

    if (this.params == 'ltcMetroArea') {
      // this.resetFormBooleanValue();
      this.isLTCMetroAreaSelection = true;
      this.isEnableUpdateButton = true;
    } else if (this.params == 'additionalQuestions') {
      // this.resetFormBooleanValue();
      this.isAdditionalQuestion = true;
      this.isEnableUpdateButton = true;
    } else {
      this.isLTCMetroAreaSelection = true;
    }

    this.metroAreaForm = new FormGroup({
      //TODO: do we add state info here for each person as well? Just keep if in form?
      clientMetroRegion: new FormControl('', Validators.required),
      spouseMetroRegion: new FormControl(''), //TODO: if couple, make this:  Validators.required
      //NOTE: I think this is only used on cobo reports
      applySameMetroRegionForSpouse: new FormControl(false) //default on page load
    });

    this.additionalQuestionsForm = new FormGroup( {
      Firm: new FormControl(),
      Wholesaler: new FormControl(),
      RepName: new FormControl(),
      PlanSponsor: new FormControl(),
      SendReportTo: new FormControl(),
      MeetingReference: new FormControl(),
      ReportRequestFrom: new FormControl()
    })

    //required for page refresh when updating client profile
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };
  }

  ngOnInit() {  


    //this.clientSpouseFullName = localStorage.getItem('clientSpouseFullName');
    this.isMarried = localStorage.getItem('isMarried') == "true"? true: false;

    this.getClient();
  }

  next(scenario) {
    this.resetFormBooleanValue();
    if (scenario == 'metroAreaForm') {
      this.isLTCMetroAreaSelection = false;
      this.isAdditionalQuestion = true;

      if (this.client && this.client.additionalQuestion && this.client.additionalQuestion.FromHCLTCComb == "LTC")
        this.isEnableUpdateButton = true;
    }
    if (scenario == 'additionalQuestionsForm') {
      this.updateClientProfileWithLTCQuestionnaire();
    }
  }

  previous(scenario) {
    console.log('scenario', scenario)
    this.resetFormBooleanValue();
    if (scenario == 'metroAreaForm') {
      this.router.navigate(['/clients/edit'])
    }
    if (scenario == 'additionalQuestionsForm') {
      this.isAdditionalQuestion = false;
      this.isLTCMetroAreaSelection = true;
    }
  }

  resetFormBooleanValue() {
    this.isLTCMetroAreaSelection = this.isLTCMetroAreaSelection = this.isAdditionalQuestion = this.isEnableUpdateButton = false;
  }

  update() {
    this.updateClientProfileWithLTCQuestionnaire();
  }

  cancel() {
    this.router.navigate(['/clients/edit']);
  }

  client;
  error;
  getClient() {
    this.globalService.getClientData(Number(localStorage.getItem("selectedClient")), 4)
      .subscribe(
        client => {
          this.client = client;
          //this.mapToClientObject(client);
          this.client.clientProfile.Spouses = JSON.parse(this.client.clientProfile.Spouses);

          if (this.client.clientProfile.Spouses.length > 1) {
            this.client.clientProfile.Spouses = Utils.calculateMostProfitableSpouse(this.client, this.client.clientProfile.Spouses);
          }

          if (this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married')
            this.isMarried = true;
          else {
            this.isMarried = false;
          }

          this.clientSpouseFullName = client.clientProfile && client.clientProfile.Spouses[0] && client.clientProfile.Spouses[0].maritalStatus == 'Married' ?
          (client.client.LastName == client.clientProfile.Spouses[0].lastName) ? 
                client.client.FirstName + ' and ' + client.clientProfile.Spouses[0].firstName + ' ' + client.client.LastName :
                client.client.FirstName + ' ' + client.client.LastName + ' and ' + client.clientProfile.Spouses[0].firstName + ' ' + client.clientProfile.Spouses[0].lastName
                : client.client.FirstName + ' ' + client.client.LastName;

          this.clientSelectedState = this.allStates.find(({abbreviation}) => abbreviation === client.clientProfile.RetirementState);
          if(this.isMarried){
            this.spouseSelectedState = this.allStates.find(({abbreviation}) => abbreviation === client.clientProfile.Spouses[0].state);
            if(this.client.clientProfile.ClientMetroArea && this.client.clientProfile.SpouseMetroArea && client.clientProfile.Spouses[0].state == client.clientProfile.RetirementState
              && (client.clientProfile.Spouses[0].state != 'NA' && client.clientProfile.RetirementState != 'NA')){
                if(this.client.clientProfile.ClientMetroArea == this.client.clientProfile.SpouseMetroArea){
                  this.metroAreaForm.controls['applySameMetroRegionForSpouse'].setValue(true);
                }
            }
          }
          //this.client.clientProfile.Children = JSON.parse(this.client.clientProfile.Children);
          this.getLTCStateRegions(client.clientProfile.RetirementState, true);
          if(this.isMarried){
            this.getLTCStateRegions(client.clientProfile.Spouses[0].state, false);
          }          
        },
        error => this.error = <any>error);
  }


  getLTCStateRegions(state, isClient){
    this.globalService.getLTCStateRegions(state)
      .subscribe(
          data => {
            console.log('metro regions', data);
            if(isClient){
              this.clientLTCMetroRegions = data;
            } else {
              this.spouseLTCMetroRegions = data;  
            }
            
            //we need to do a check to make this backwards compatible for already existing clients
            /* if(client.clientProfile.ClientMetroArea == ''){
              if(this.responseLTCMetroRegions.Rows.some(item => item.MetroRegionCode != client.clientProfile.ClientMetroArea)){
                //if in here, we need to set metro region to 'State Average'
                this.retireInfo.controls['retirementStateMetroArea'].setValue('0');
              }
            } */
           
          this.insertDataToLTCQuestionnaire();
          },
          error => console.log(error));
  }

  updateClientProfileWithLTCQuestionnaire() {
    var ClientProfile = {
      ClientID: this.client.clientProfile.ClientID,
      MaritalStatus: this.client.clientProfile.MaritalStatus,
      CurrentIncome: this.client.clientProfile.CurrentIncome,
      IRR: this.client.clientProfile.IRR ,
      RetirementAge: this.client.clientProfile.RetirementAge,
      Pension: this.client.clientProfile.Pension,
      RetirementState: this.client.clientProfile.RetirementState,
      SpouseID: this.client.clientProfile.SpouseID,
      LifeExpectancy: this.client.clientProfile.LifeExpectancy,
      HCHBP: this.client.clientProfile.HCHBP ? 1 : 0,
      HCHC: this.client.clientProfile.HCHC ? 1 : 0,
      HCT2D: this.client.clientProfile.HCT2D ? 1 : 0,
      HCCD: this.client.clientProfile.HCCD ? 1 : 0,
      HCC: this.client.clientProfile.HCC ? 1 : 0,
      HCT: this.client.clientProfile.HCT ? 1 : 0,

      HCALZ: this.client.clientProfile.HCALZ ? 1 : 0,
      HCPARK: this.client.clientProfile.HCPARK ? 1 : 0,
      HCAMP: this.client.clientProfile.HCAMP ? 1 : 0,
      HCPTSD: this.client.clientProfile.HCPTSD ? 1 : 0,
      HCOBS: this.client.clientProfile.HCOBS ? 1 : 0,

      Spouses: JSON.stringify(this.client.clientProfile.Spouses),
      Children: this.client.clientProfile.Children && this.client.clientProfile.Children.length > 0 ? this.client.clientProfile.Children : null,//JSON.stringify(this.client.clientProfile.Children),
      PensionMonths: this.client.clientProfile.PensionMonths,
      PensionYears: this.client.clientProfile.PensionYears,
      SubstantialEarningYears: this.client.clientProfile.SubstantialEarningYears,
      IncludePension: this.client.clientProfile.IncludePension,
      PIA: this.client.clientProfile.PIA,
      PIAYears: (!this.client.clientProfile.PIAYears || this.client.clientProfile.PIAYears == 'null') ? null : JSON.stringify(this.client.clientProfile.PIAYears),
      UseNationalAverage: this.client.clientProfile.UseNationalAverage,
      IsRunReportWithSpouse: this.client.clientProfile.IsRunReportWithSpouse,
      IsLegalSpouse: this.client.clientProfile.IsLegalSpouse,
      HCT1D: this.client.clientProfile.HCT1D ? 1 : 0,
      HCMS: this.client.clientProfile.HCMS ? 1 : 0,
      HCDCW: this.client.clientProfile.HCDCW ? 1 : 0,
      HCFHDC: this.client.clientProfile.HCFHDC ? 1 : 0,
      IsPrivHealthIns: this.client.clientProfile.IsPrivHealthIns,
      CoverageType: this.client.clientProfile.CoverageType,
      PremiumType: this.client.clientProfile.PremiumType,
      Premiums:  this.client.clientProfile.Premiums, // ? JSON.stringify(this.client.clientProfile.Premiums): null,
      IsHSApplySpouse: this.client.clientProfile.IsHSApplySpouse,
      IsSpousePrivHealthIns: this.client.clientProfile.IsSpousePrivHealthIns,
      SpouseCoverageType: this.client.clientProfile.SpouseCoverageType,
      SpousePremiumType: this.client.clientProfile.SpousePremiumType,
      SpousePremiums: this.client.clientProfile.SpousePremiums,
      Bracket: this.client.clientProfile.Bracket,
      InflationRate: this.client.clientProfile.InflationRate,
      HouseholdYearOneIncome: this.client.clientProfile.HouseholdYearOneIncome,
      HouseholdYearOneIncomeChangeYear: this.client.clientProfile.HouseholdYearOneIncomeChangeYear,
      InRetirementInflationRate: this.client.clientProfile.InRetirementInflationRate,
      MAGIPercentIncome: this.client.clientProfile.MAGIPercentIncome,
      OOPCosts: this.client.clientProfile.OOPCosts,// ? JSON.stringify(JSON.parse(this.client.clientProfile.OOPCosts)): null,
      SpouseOOPCosts: this.client.clientProfile.SpouseOOPCosts,// ? JSON.stringify(this.client.clientProfile.SpouseOOPCosts): null,
      ClientMetroArea: this.metroAreaForm.value.clientMetroRegion,
      SpouseMetroArea: this.metroAreaForm.value.applySameMetroRegionForSpouse ? this.metroAreaForm.value.clientMetroRegion : this.metroAreaForm.value.spouseMetroRegion
    }

    var UserModel = {
      ID: this.client.client ? this.client.client.ID : 0,
      FirstName: this.client.client.FirstName,
      LastName: this.client.client.LastName,
      AdvisorID: this.client.client.AdvisorID,
      OrganizationID: this.client.client.OrganizationID,
      Username: this.client.client.Username,
      GenderID: this.client.client.GenderID,
      DOB: this.client.client.DOB,
      Email: this.client.client.Email,
      Phone: this.client.client.Phone,
      Address: this.client.client.Address,
      City: this.client.client.City,
      State: this.client.client.State,
      Zip: this.client.client.Zip,
    }
    var RiskTolerance = null;
    var AdditionalQuestion = null;

    if (this.params == '' || this.params == 'emptyAll' || this.isEditAll) {
    AdditionalQuestion = {
      Firm: this.additionalQuestionsForm.value.Firm,
      PlanSponsor: this.additionalQuestionsForm.value.PlanSponsor,
      Wholesaler: this.additionalQuestionsForm.value.Wholesaler,
      SendReportTo: this.additionalQuestionsForm.value.SendReportTo,
      RepName: this.additionalQuestionsForm.value.RepName,
      MeetingReference: this.additionalQuestionsForm.value.MeetingReference,
      ReportRequestFrom: this.additionalQuestionsForm.value.ReportRequestFrom,
      FromHCLTCComb: 'LTC'
    }
  }

  console.log('AdditionalQuestion', AdditionalQuestion);

    this.globalService.createClient(UserModel, ClientProfile , RiskTolerance, AdditionalQuestion)
    .subscribe(
      resp => {
        if (this.isEnableUpdateButton) {
          this.router.navigate(['/clients/edit']);
        } else {
          //this.router.navigate(['/reports/long-term-care/options']);
          this.router.navigate(['/clients/edit/long-term-care/options']);
        }
      },
      error => {

      });
  }

  insertDataToLTCQuestionnaire() {
    if (this.params == 'ltcMetroArea' || this.isEditAll) {
      this.metroAreaForm.controls['clientMetroRegion'].setValue ((this.client.clientProfile.ClientMetroArea) ? this.client.clientProfile.ClientMetroArea : "");
      if (this.isMarried) {
        this.metroAreaForm.controls['spouseMetroRegion'].setValue ((this.client.clientProfile.SpouseMetroArea) ? this.client.clientProfile.SpouseMetroArea : "");
      }
      console.log('this.metroAreaForm', this.metroAreaForm.value.clientMetroRegion);

    }
    if(this.isEditAll || this.params == 'additionalQuestions') {
      console.log('set LTC additional quest')
      let firm = this.client.additionalQuestion ? this.client.additionalQuestion.Firm : '';
      let planSponsor = this.client.additionalQuestion ? this.client.additionalQuestion.PlanSponsor : '';
      let wholeSaler = this.client.additionalQuestion ? this.client.additionalQuestion.Wholesaler : '';
      let sendReportTo = this.client.additionalQuestion ? this.client.additionalQuestion.SendReportTo : '';
      let repName = this.client.additionalQuestion ? this.client.additionalQuestion.RepName : '';
      let meetingReference = this.client.additionalQuestion ? this.client.additionalQuestion.MeetingReference : '';
      let reportRequestFrom = this.client.additionalQuestion ? this.client.additionalQuestion.ReportRequestFrom : '';
      this.additionalQuestionsForm.controls['Firm'].setValue(firm);
      this.additionalQuestionsForm.controls['PlanSponsor'].setValue(planSponsor);
      this.additionalQuestionsForm.controls['Wholesaler'].setValue(wholeSaler);
      this.additionalQuestionsForm.controls['SendReportTo'].setValue(sendReportTo);
      this.additionalQuestionsForm.controls['RepName'].setValue(repName);
      this.additionalQuestionsForm.controls['MeetingReference'].setValue(meetingReference);
      this.additionalQuestionsForm.controls['ReportRequestFrom'].setValue(reportRequestFrom);

      console.log('Add Questions Form', this.additionalQuestionsForm.value);
    }
  }

  validateString(val, isRequired) {
    var regex = /^[a-zA-Z ]{2,30}$/;
    return val ? regex.test(val) : !isRequired;
  }

  selectMetro(){
    if(this.metroAreaForm.value.applySameMetroRegionForSpouse){
      this.metroAreaForm.controls['spouseMetroRegion'].enable();
      this.metroAreaForm.controls['spouseMetroRegion'].setValue(this.metroAreaForm.value.clientMetroRegion);
      this.metroAreaForm.controls['spouseMetroRegion'].disable();
    } else {
      if(this.isMarried){
        this.metroAreaForm.controls['spouseMetroRegion'].enable();
      }
    }
  }
}
